import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "22",
  y: "22",
  width: "21.9998",
  height: "22",
  rx: "10.9999",
  transform: "rotate(-180 22 22)",
  fill: "#EFF0F1"
}, null, -1)
const _hoisted_3 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'arrowLeft',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
  width: {
    type: Number as PropType<number | string>,
    default: 22,
  },
  height: {
    type: Number as PropType<number | string>,
    default: 22,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 22 22",
    fill: "none"
  }, [
    _hoisted_2,
    _createElementVNode("path", {
      d: "M11.7808 7.1537L7.70598 10.7482C7.67177 10.7806 7.64451 10.8196 7.62589 10.8629C7.60726 10.9062 7.59766 10.9528 7.59766 10.9999C7.59766 11.047 7.60726 11.0936 7.62589 11.1368C7.64451 11.1801 7.67177 11.2191 7.70598 11.2515L11.7808 14.846C11.8132 14.8748 11.851 14.8968 11.8919 14.9108C11.9329 14.9248 11.9762 14.9306 12.0194 14.9277C12.0629 14.9242 12.1053 14.9119 12.144 14.8917C12.1828 14.8715 12.2171 14.8438 12.2449 14.8101L12.7514 14.2055C12.7799 14.1725 12.8016 14.1341 12.8151 14.0926C12.8285 14.051 12.8335 14.0072 12.8298 13.9637C12.8267 13.9204 12.8149 13.8782 12.7953 13.8395C12.7757 13.8008 12.7485 13.7664 12.7154 13.7382L9.62741 11.0554C9.61105 11.0389 9.60187 11.0166 9.60187 10.9933C9.60187 10.9701 9.61105 10.9478 9.62741 10.9312L12.7154 8.26147C12.7785 8.20865 12.8194 8.13396 12.8298 8.05233C12.834 8.00905 12.8295 7.96537 12.8166 7.92385C12.8037 7.88233 12.7826 7.8438 12.7546 7.81052L12.2449 7.18964C12.2171 7.15596 12.1828 7.12819 12.144 7.10799C12.1053 7.08778 12.0629 7.07555 12.0194 7.072C11.9762 7.06914 11.9329 7.07489 11.8919 7.08892C11.851 7.10294 11.8132 7.12496 11.7808 7.1537Z",
      fill: __props.color
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})